import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FdesCalcModelVersion } from '../_models/fdesCalcModelVersion';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class FdesCalcModelService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getVersions() {
    return this.http.get<FdesCalcModelVersion[]>(`${environment.apiUrl}/fdescalcmodel/versions`, { headers: this.authService.headers });
  }

  // checks the workbook without publishing it — same controls as publish
  validate(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.apiUrl}/fdescalcmodel/validate`, formData, { headers: this.authService.headers });
  }

  publish(version: string, file: File) {
    const formData = new FormData();
    formData.append('version', version);
    formData.append('file', file);
    return this.http.post<FdesCalcModelVersion>(`${environment.apiUrl}/fdescalcmodel`, formData, { headers: this.authService.headers });
  }

  // the workbook is stored under its GUID — the endpoint serves it back under its original file name
  downloadFile(id: string) {
    return this.http.get<Blob>(`${environment.apiUrl}/fdescalcmodel/${id}/file`, {
      headers: this.authService.headers,
      responseType: 'blob' as 'json'
    });
  }
}
